var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { CampaignService } from './campaign.service';
var CampaignStepComponent = /** @class */ (function (_super) {
    __extends(CampaignStepComponent, _super);
    function CampaignStepComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.readonly = false;
        _this.steps = [];
        return _this;
    }
    CampaignStepComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.component.params['readonly'] === true) {
            this.readonly = true;
        }
        if (typeof this.component.params['steps'] !== 'undefined') {
            this.steps = this.component.params['steps'];
        }
    };
    CampaignStepComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.refSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    CampaignStepComponent.prototype.onModeSubscribe = function (mode) {
        this.setAnchor(mode);
    };
    CampaignStepComponent.prototype.onEvent = function (e1, e2, rec) {
        this.action.firstAction(e2, { buttonType: 'button' });
    };
    CampaignStepComponent.prototype.setAnchor = function (mode) {
        var disabled = false;
        for (var _i = 0, _a = this.steps; _i < _a.length; _i++) {
            var step = _a[_i];
            var styles = [];
            styles.push('stageFlow_anchor');
            if (disabled && !this.readonly) {
                styles.push('stageFlow_anchor-disabled');
            }
            if (mode === step.mode) {
                styles.push('stageFlow_anchor-current');
                disabled = true;
            }
            step.style = styles.join(' ');
        }
    };
    CampaignStepComponent.prototype.trackByStep = function (index, step) {
        return step.label;
    };
    CampaignStepComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'campaign-step',
                    template: "<div class=\"stageFlow\" id=\"{{ componentName }}\">\n  <ul class=\"stageFlow_ul\">\n    <li *ngFor=\"let step of steps; let index = index; trackBy: trackByStep\" class=\"stageFlow_li\">\n      <a [ngClass]=\"step.style\" href=\"javascript:void(0);\" (click)=\"onEvent($event, step.event)\">{{ (msg | async)[step.label] || step.label }}</a>\n    </li>\n  </ul>\n  <div class=\"stageFlow_content\">\n    <content *ngFor=\"let component of component.components\" [component]=\"component\"></content>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    CampaignStepComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: CampaignService }
    ]; };
    return CampaignStepComponent;
}(ContentBaseComponent));
export { CampaignStepComponent };
var Step = /** @class */ (function () {
    function Step() {
    }
    return Step;
}());
//# sourceMappingURL=campaign-step.component.js.map